export const formatNumber = (num) => {
	return new Intl.NumberFormat().format(num);
};
